import { Component, EventEmitter, Output, Input, AfterViewInit, ChangeDetectorRef  } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-tracking-tracker-filter',
  templateUrl: './tracking-tracker-filter.component.html',
  styleUrls: ['./tracking-tracker-filter.component.scss'],
  imports: [FormsModule],
})
export class TrackingTrackerFilterComponent implements AfterViewInit {

  public inputValue: string;
  @Input() public placeholder: string;
  @Output() public inputChange = new EventEmitter<string>();

  constructor(private cdref: ChangeDetectorRef) {}

  // public ngOnInit(): void {
  // }

  public onChange(): void {
    this.inputChange.emit(this.inputValue);
  }

  public clearFilter(): void {
    this.inputValue = '';
    sessionStorage.removeItem('MBL');
    sessionStorage.removeItem('HBL');
    sessionStorage.removeItem('Container');
    sessionStorage.removeItem('CustomerRef');
    sessionStorage.removeItem('ShipmentCode');
    this.onChange();
  }

  private valueInSession(): boolean {
    return sessionStorage.getItem('MBL') !== null ||
      sessionStorage.getItem('HBL') !== null ||
      sessionStorage.getItem('Container') !== null ||
      sessionStorage.getItem('CustomerRef') !== null ||
      sessionStorage.getItem('ShipmentCode') !== null;
  }

  public ngAfterViewInit(): void {
    if (this.valueInSession()) {
      if (this.placeholder === 'Search Master BL/AWB#') {
        this.inputValue = sessionStorage.getItem('MBL');
      } else if (this.placeholder === 'Search House B/L#') {
        this.inputValue = sessionStorage.getItem('HBL');
      } else if (this.placeholder === 'Search Container#') {
        this.inputValue = sessionStorage.getItem('Container');
      } else if (this.placeholder === 'Search Order/Ref/INV#') {
        this.inputValue = sessionStorage.getItem('CustomerRef');
      } else if (this.placeholder === 'Search Shipment Number#') {
        this.inputValue = sessionStorage.getItem('ShipmentCode');
      } else {
        this.inputValue = '';
      }
 //     this.cdref.detectChanges();
    }
  }
}
